import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Chip, Paper } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { BellIcons } from '../../icons/icons';
import { NAVBAR_MENU_KEYS, NS } from '../../i18n/constants/keys';

export const MobileNotifications: React.FC = () => {
  const { t } = useTranslation(NS.navbarMenus);
  const [notifications] = useState<string[]>([]);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={(theme) => ({
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 32,
              height: 32,
              borderRadius: 1.5,
              bgcolor: alpha(theme.palette.primary.main, 0.1),
              color: theme.palette.primary.main,
            })}
          >
            <BellIcons size={16} />
          </Box>
          <Typography
            variant="caption"
            sx={{
              fontWeight: 800,
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              color: 'text.secondary',
            }}
          >
            {t(NAVBAR_MENU_KEYS.notifications.title)}
          </Typography>
        </Box>
        {notifications.length > 0 && (
          <Chip
            size="small"
            color="error"
            label={notifications.length}
            sx={{ height: 20, fontSize: '0.7rem', fontWeight: 700 }}
          />
        )}
      </Box>

      {notifications.length === 0 ? (
        <Box
          sx={{
            py: 1.5,
            px: 2,
            borderRadius: 1.5,
            bgcolor: (theme) => alpha(theme.palette.text.primary, 0.04),
            color: 'text.secondary',
            fontSize: '0.8125rem',
            fontWeight: 600,
            textAlign: 'center',
          }}
        >
          {t(NAVBAR_MENU_KEYS.notifications.emptyMobile)}
        </Box>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {notifications.map((notification, index) => (
            <Box
              key={index}
              sx={{
                p: 1.5,
                borderRadius: 1.5,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: (theme) => alpha(theme.palette.text.primary, 0.02),
                fontSize: '0.875rem',
                color: 'text.primary',
              }}
            >
              {notification}
            </Box>
          ))}
        </Box>
      )}
    </Paper>
  );
};
